import { RequireAuth } from "./components/auth";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import Signup from "./pages/signup";
import Login from "./pages/login";
import AppHouse from "./pages/appHouse";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentModal from "./components/paymentModal";
import PasswordReset from "./pages/passwordReset";
import ConfirmReset from "./pages/confirmReset";
import Footer from "./components/footer";
import Header from "./components/header";
import Privacy from "./components/privacy";
import Terms from "./components/terms";
import "@tremor/react/dist/esm/tremor.css";
import BizVerification from "./pages/marketingpages/BizVerification";
import IDV from "./pages/marketingpages/IDV";
import BiometricVerification from "./pages/marketingpages/BiometricVerification";
import ComputerVision from "./pages/marketingpages/ComputerVision";

import useAuth from "./hooks/useAuth";
import Landing from "./pages/landing";
import Pricing from "./pages/pricing";
import DataAnnotation from "./pages/data-annotation";
import ModelFineTuning from "./pages/model-fine-tuning";
import SLM from "./pages/small-language-models";
import ComputerVisionPage from "./pages/computer-vision";

function App() {
  const { authed } = useAuth();
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <PaymentModal />
      <Routes>
        <Route exact path="/terms" element={<Terms />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route
          path="/signup"
          element={!authed ? <Signup /> : <Navigate to="/app" />}
        />
        <Route
          path="/login"
          element={!authed ? <Login /> : <Navigate to="/app" />}
        />
        <Route path="/reset" element={<PasswordReset />} />
        <Route path="/confirmreset" element={<ConfirmReset />} />
        <Route path="/businessverification" element={<BizVerification />} />
        <Route path="/identitydocumentverification" element={<IDV />} />
        <Route
          path="/biometricverification"
          element={<BiometricVerification />}
        />
        <Route path="/computervision" element={<ComputerVision />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route
          path="/app/*"
          element={
            <RequireAuth>
              <div className="contain-body">
                <Header />
                <AppHouse />
                <Footer />
              </div>
            </RequireAuth>
          }
        />
        <Route path="/" element={<Landing />} />
        <Route path="/data-annotation" element={<DataAnnotation />} />
        <Route path="/model-fine-tuning" element={<ModelFineTuning />} />
        <Route path="/small-language-models" element={<SLM />} />
        <Route path="/computer-vision" element={<ComputerVisionPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <style jsx="true">
        {`
          .contain-body {
            display: flex;
            flex-direction: column;
            min-height: 100vh;
          }
        `}
      </style>
    </>
  );
}

export default App;
